<template>
  <div>

    <Head style="backgroundColor: #fff;"></Head>
    <navigationbar ref="navbar"  @change='changenavigation'></navigationbar>
    <div class="firstdiv"></div>
    <div class="content flex flex-direction align-center">
      <div class="flex flex-direction width "
           style="height: auto; margin-top: 0.4rem ">
        <div class="top flex flex-direction">
          <div v-if="length>1 && !filterAge"
               class="flex  classify align-center font-size-22">

            <p class=" font-color-0cb"
               style="margin-left:0.22rem;margin-right:0.22rem;  white-space: nowrap; flex-shrink: 0;">一级分类</p>
            <div class="flex flex-wrap">
              <p @click="catalogsCheck(index)"
                 class="choose cursor-pointer"
                 :class="index == firstIndex?'check':'uncheck'"
                 v-for="(item, index) in catalogs"
                 :key="index">
                {{item.CatalogName}}
              </p>
            </div>
          </div>
          <div v-if="lengther>1 && !filterAge"
               class="flex  classify align-center font-size-22">
            <p class=" font-color-0cb"
               style="margin-left:0.22rem;margin-right:0.22rem; flex-shrink: 0;">二级分类</p>
            <div class="flex flex-wrap">
              <p @click="ercatalogsCheck(index)"
                 class="choose cursor-pointer"
                 :class="index == secondIndex?'check':'uncheck'"
                 v-for="(item, index) in ercatalogs"
                 :key="index">
                {{item.CatalogName}}
              </p>
            </div>
          </div>
          <div class="flex classify align-center font-size-22">
            <p class=" font-color-0cb"
               style="margin-left:0.22rem;margin-right:0.22rem">综合排序</p>
            <p @click="thirdCheck(index)"
               class="choose cursor-pointer"
               :class="index == thirdIndex?'check':'uncheck'"
               v-for="(item, index) in thirdClassify"
               :key="index">
              {{item.name}}
            </p>
          </div>
        </div>
        <div class="bottom flex flex-direction ">
           <div v-if="course_length" class="res-count">
            <p class="font-size-16">当前资源共{{courseCount}}门课程，{{videoCount}}篇视频</p>
          </div>

          <div v-if="course_length>0" class="flex flex-direction">
            <div class="itemdiv">
              <courseItem v-for="(item, index) in dataList"
                          :key="index"
                          :item="item"
                          :OrderBy='thirdIndex+1'
                          style="margin-top: 0.36rem; margin-left: 0.26rem">
              </courseItem>
            </div>
            <div style="margin: 0.5rem auto; display: flex; justify-content: center;">

              <paginate ref="paginate" v-if="totalPage>0"
                        :total="courseCount"
                        :pages="totalPage"
                        @jump="jumpPage"
                        :groups="totalPage>5?5:totalPage"></paginate>
            </div>
          </div>

           <div v-else-if="course_length==0 && loading==false"
                   class="empty font-color-94 flex flex-direction justify-center align-center font-size-36">
                <img style="width: 3.66rem; heigh: 3.32rem"
                     src="../../../assets/pserson/empty.png" />
                空空如也，没有找到课程~
              </div>


          <!-- <div v-else-if="course_length==0 && loading==false" class='error-page flex flex-center'>
            <p class="font-size-24">暂无课程</p>
          </div> -->
          <div v-if="loading" class="loading flex justify-center" style="min-height: 9.82rem; margin-top: 1rem;">
            <span class="size bg-color-23"></span>
            <span class="size bg-color-23"></span>
            <span class="size bg-color-23"></span>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from "@/utils/common.js";
export default {
  data () {
    return {
      loading: false,
      catalogType: 0,
      totalPage: 0,
      pageIndex: 1,
      firstIndex: 0,
      secondIndex: 0,
      thirdIndex: 0,
      fourIndex: 0,
      catalogs: [],
      allCatalogs: [],
      ercatalogs: [],
      sel_id:0,
      // 排序 最新发布-publishtime 最多学习-study 最多喜欢-like 最多分享-share
      thirdClassify: [{
        name: '最新发布', TypeName: 'publishtime'
      }, {
        name: '最多学习', TypeName: 'study'
      }, {
        name: '最多喜欢', TypeName: 'like'
      }, {
        name: '最多分享', TypeName: 'share'
      }],
      fourClassify: ['全部', '单集', '系列'],
      dataList: [],

      filterAge: false,

      courseCount: 0,
      videoCount: 0
    };
  },
  computed: {
    length () {
      return this.catalogs.length
    },
    lengther () {
      return this.ercatalogs.length
    },
    course_length(){
      return this.dataList.length
    }
  },

  beforeCreate () {

  },
  watch:{
    sel_id(){
    this.$refs.navbar.setCurrId(this.sel_id, this.catalogType)

    let query = this.$router.history.current.query;
    query.p = this.sel_id

    this.catalogs = []
    this.allCatalogs = []
    this.ercatalogs = []
    this.totalPage = 0
    this.pageIndex = 1
    this.firstIndex = 0
    this.secondIndex = 0
    this.thirdIndex = 0
    this.fourIndex = 0
    this.dataList = []
    let find = false;
    for (let index = 0; index < common.cate_fr.length; index++) {
      const element = common.cate_fr[index];
      if (element.Id == this.sel_id) {
        var item = {
          CatalogName: "全部",
          Id: element.Id,
          Level: element.Level,
          Order: element.Order,
          ParentId: element.ParentId
        }
        this.catalogs.push(item);
        this.ercatalogs.push(item);
        find = true;
        this.getCatalog();
        this.getCourses();
        return
      }
    }
    if (find == false) {
      this.$router.replace({
        name: "home",
      });
    }
    }
  },
  created () {
    this.catalogType = parseInt(this.$route.query.type) || 1
    this.sel_id = parseInt(this.$route.query.id) || 0
  },
  methods: {
    changenavigation(val){ 
      this.sel_id = val.id
      this.catalogType = val.type
    },
    jumpPage (page) {
      this.pageIndex = page
      this.getCourses();
    },
    // 获取分类
    getCatalog () {
      var that = this;
      this.getRequest('api/v1/Catalog', {
        Id: this.ercatalogs[this.secondIndex].Id,
      }).then(data => {
        console.log(data);
        if (data.IsSuccess) {
          for (var i = 0; i < data.Data.length; i++) {
            if (data.Data[i].Level == 2) {
              that.catalogs.push(data.Data[i])
            } else if (data.Data[i].Level == 3) {
              that.allCatalogs.push(data.Data[i])
            }
          }
        }
      })
    },

    //二级选中
    catalogsCheck (index) {
      if (this.firstIndex != index) {
        this.firstIndex = index;
        var list = [{
          CatalogName: "全部",
          Id: this.catalogs[index].Id,
          Level: this.catalogs[index].Level,
          Order: this.catalogs[index].Order,
          ParentId: this.catalogs[index].ParentId,
        }]
        for (var i = 0; i < this.allCatalogs.length; i++) {
          if (this.catalogs[index].Id == this.allCatalogs[i].ParentId) {
            list.push(this.allCatalogs[i]);
          }
        }
        this.secondIndex = 0;
        this.pageIndex = 1;
        this.ercatalogs = list;
        this.getCourses();
      }
    },
    //三级选中
    ercatalogsCheck (index) {
      if (this.secondIndex != index) {
        this.secondIndex = index;
        this.pageIndex = 1;
        this.getCourses();
      }
    },
    // 获取课程列表
    getCourses () {
      this.loading = true
      var that = this;
      this.getRequest('api/v1/Course', {
        CatalogId: this.ercatalogs[this.secondIndex].Id,
        OrderBy: this.thirdClassify[this.thirdIndex].TypeName,
        IsSingle: this.fourIndex,
        PageIndex: this.pageIndex,
        CatalogType: this.catalogType,
        PageSize: 32
      }).then(data => {
        this.loading = false
        console.log(data);
        if (data.IsSuccess) {
          that.courseCount = data.Data.TotalCount
          that.videoCount = data.Data.VideosCount
          that.totalPage = data.Data.TotalPage
          that.dataList = data.Data.Courses
        }
      }).catch((_)=>{
        this.loading = false
      })
    },
    thirdCheck (index) {
      if (this.thirdIndex != index) {
        this.thirdIndex = index;
        this.pageIndex = 1;
        this.getCourses();

        this.$refs.paginate.changePage(1)
      }
    },
    fourCheck (index) {
      if (this.fourIndex != index) {
        this.fourIndex = index;
        this.pageIndex = 1;
        this.getCourses();
      }
    },

  },
};
</script>

<style scoped>
.firstdiv {
  background: url("../../../assets/icon-bg.jpg");
  background-size: cover;
  background-position: center bottom;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
  /* background-size: 100% auto; */
  position: fixed;
  /* height: 5.05rem; */
  top: 0;
  left: 0;
  z-index: -1;
  background-color: #cbfeee;
}

.content {
  padding-bottom: 0.56rem;
}

.top {
  z-index: 3;
  /* min-height: 1.86rem; */
  padding: 0 0.44rem;
  background: #ffffff;
  box-shadow: 0 0 0.22rem 0.05rem rgba(155, 199, 219, 0.35);
  border-radius: 0.16rem;
}
.top .classify {
  /* padding: 0.1rem 0; */
  border-bottom: 1px solid rgba(211, 211, 211, 0.5);
  min-height: 0.9rem;
}
.top .last {
  height: 0.93rem;
}
.choose {
  height: 0.45rem;
  line-height: 0.45rem;
  min-width: 1.2rem;
  padding: 0 0.2rem;
  margin: 0.1rem 0;
  text-align: center;
  white-space: nowrap;
  border-radius: 0.25rem;
}
.choose:hover {
  color: #ffffff;
  background: #ffcb05;
}

.check {
  color: #ffffff;
  background: #ffcb05;
}
.uncheck {
  color: #1b1b1b;
  background: #ffffff;
}

.bottom {
  width: 100%;
  margin-top: 0.34rem;
  z-index: 3;
  background: #ffffff;
  box-shadow: 0 0 0.22rem 0.05rem rgba(155, 199, 219, 0.35);
  border-radius: 0.16rem;
}
.bottom .itemdiv {
  flex-wrap: wrap;
  display: flex;
  flex-grow: 1;
  min-height: 9.82rem;
  align-content: flex-start;
}

.res-count {
  height: 0.4rem;
  padding: 0.3rem 0.26rem 0;
}


.res-count p {
  font-family: fangzheng-font-custom;
}

.error-page {
  height: 3rem;
}

.empty {
  width: 100%;
  margin-top: 0.6rem;
  margin-bottom: 0.44rem;
}

.empty p {
  margin-top: 0.4rem;
  width: 3.27rem;
  height: 0.67rem;
  background: #ffcb05;
  border-radius: 0.34rem;
  text-align: center;
  line-height: 0.67rem;
}

.empty p img {
  width: 0.13rem;
  height: 0.22rem;
}


</style>



// WEBPACK FOOTER //
// src/view/tab/navigation/list.vue